<template>
  <content-element
    :id="id"
    :type="type"
    :links="links"
    :meta="meta"
    :attributes="attributes"
    :relationships="relationships"
    :fluid="fluid"
  />
</template>
<script>
import { parseDataAttributeJson } from '@/js/helper/data-attribute-helper.js'

import ContentElement from './ContentElement/ContentElement.vue'

export default {
  name: 'SingleElementContent',
  components: { ContentElement },
  props: {
    element: {
      type: String,
      default: '',
    },
    fluid: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return parseDataAttributeJson(this.element)
  },
}
</script>
